import { render, staticRenderFns } from "./Capture.vue?vue&type=template&id=4299af42&scoped=true&"
import script from "./js/capture.js?vue&type=script&lang=js&"
export * from "./js/capture.js?vue&type=script&lang=js&"
import style0 from "./Capture.vue?vue&type=style&index=0&id=4299af42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4299af42",
  null
  
)

export default component.exports